<template>
    <div class="mobile-factoring-payment-plan-container">
    <!-- 顶部 -->
    <el-row>
      <el-col :span="24">
        <div class="content-col">
          <div class="content-title">流程名称</div>
          <div class="init-content top-title">{{processDetail.process?processDetail.process.processDefinitionName:''}}</div>
        </div>
      </el-col>      
      <el-col :span="12">
        <div class="content-col">
          <div class="content-title">业务主办、协办</div>
          <div class="init-content">{{basicInfoData.managerUserName?basicInfoData.managerUserName:''}}{{basicInfoData.assistUserName?`、${basicInfoData.assistUserName}`:''}}</div>
        </div>
      </el-col>
      <!-- <el-col :span="8">
        <div class="content-col">
          <div class="content-title">流水号</div>
          <div class="init-content">{{basicInfoData.number?basicInfoData.number:''}}</div>
        </div>
      </el-col> -->
      <el-col :span="12">
        <div class="content-col">
          <div class="content-title">提交时间</div>
          <div class="init-content">{{basicInfoData.createTime}}</div>
        </div>
      </el-col>
    </el-row>

    <el-tabs v-model="activeName" @tab-click="handleClick" stretch="true">
      <el-tab-pane label="审批信息" name="first">
        <div class="panel-container">
          <DetailList :listData="basicInfoData" />
          <!-- 审批意见 -->
          <AuditInfo
            ref="auditInfo"
            :formDetailData="auditFormData"
            :isEditable="processDetail.process?processDetail.process.isEditable:false"
            :status="(processDetail.process && processDetail.process.status)?processDetail.process.status: 'done'"
            @changeFormData="changeFormData"
          />
          <!-- 会签意见 -->
          <CommentStep
            ref="commentStep"
            :commentList="commentList"
            :status="(processDetail.process && processDetail.process.status)?processDetail.process.status: 'done'"
          />
          <!-- 流程记录 -->
          <CommentTable :flowData="flowData" />

          <!-- 与navbar同高的块 -->
          <div class="bottom-block" style="height: 2.2rem;" />
        </div>
      </el-tab-pane>

      <el-tab-pane label="公共附件" name="third">
        <BatchFileList
          v-if="uploadPermissionNameOne"
          :fileMenuUrlname="uploadPermissionNameOne"
          :fileMenuName="uploadPermissionNameTwo"
          :fileOtherId="$route.params.id"
          onlySelf="1"
        />
      </el-tab-pane>
    </el-tabs>

    <BottomLine
      ref="bottoms"
      v-if="processDetail.process.status == 'todo'"
      :processDetail="processDetail"
      :formDetailData="auditFormData"
      :mobileFormChange="mobileFormChange"
      @flowNext="flowNextMobile"
      @flowBack="flowBack"
      @refreshData="refreshData"
    />    
  </div>
</template>
<script>
import * as api from "@/api/factoring/factoringScheme";
import { lendingDetail } from '@/api/factoring/factoring'
import BatchFileList from "../../components/batchFileList"
import AuditInfo from "@/components/workflowComponents/mobile/auditInfo"
import BottomLine from "@/components/workflowComponents/mobile/bottomLine"
import CommentTable from "@/components/workflowComponents/mobile/commentTable"
import CommentStep from "@/components/workflowComponents/mobile/commentStep"
import workFlow from "@/mixins/workFlow";
import util from "@/mixins/util"
import { mapGetters } from "vuex";
// 业务明细
import DetailList from "./components/list"
import CustomerInfo from "../buildProject/components/customerInfo"
export default {
  name: "MobileFactoringPaymentPlan",
  mixins: [workFlow, util],
  data() {
    return {
      id: '',
      showCheckButton: false,
      activeName: 'first',
      processKey: "process_pre_repay",
      detailFormUrl: "/factoring/preRepayment/preRepaymentDetail",
      basicInfoData: {},
    }
  },
  components: {
    AuditInfo,
    BatchFileList,
    BottomLine,
    DetailList,
    CommentTable,
    CommentStep,
    CustomerInfo
  },
  computed: {
    ...mapGetters(["workFlowData", "userInfo", "workFlowState"])
  },
  mounted() {
    this.id = this.$route.params.id;
    this.queryFactoringPaymentPlanDetail(this.id);
  },
  methods: {
    async queryFactoringPaymentPlanDetail(id) {
      let res = await api.getDetailPlanView({ rentId: this.id });
      if(res.data.code == 200) {
        // let basicData = res.data.data
        // basicData.accountingEntityStr = await this.queryDict(basicData.accountingEntity, '/api/blade-system/dict-biz/dictionary?code=bl_accounting_entity')
        // basicData.factoringCreditStr = `${this.getMoney(basicData.factoringCredit)}元`
        this.queryLendingInfo(res.data.data.loadId, res.data.data)
        // this.basicInfoData = basicData
      }
    },

    async queryLendingInfo(id, basicData) {
      let res = await lendingDetail({ id })
      if(res.data.code == 200) {
        let resData = {}
        resData = res.data.data
        resData.payTypeStr = await this.queryDict(resData.payType, '/api/blade-system/dict-biz/dictionary?code=factoring_pay_type')
        resData.planName = resData.parentRentalName
        resData.planId = resData.parentRentalId,
        resData.innerCost = Number(resData.investMoney) - Number(resData.investShouldMoney)

        resData.assistUserName = basicData.assistUserName
        resData.managerUserName = basicData.managerUserName
        resData.planName = basicData.parentRentalName
        resData.investBatchStr = `第${resData.investBatch}批/第${resData.paymentBatch}笔`
        resData.planList = basicData.planList
        resData.prepayment = basicData.prepayment
        this.basicInfoData = resData
        // console.info(this.basicInfoData, 'basicInfoDataaaaa')

        // 查询当前流程任务数据
        this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
        // 设置流程表单路径
        this.queryProcessFormDetail(this.processDefinedId)

        this.queryFlowData(this.basicInfoData.flowableId)        
      }
    },    


    refreshData() {
      this.queryFactoringPaymentPlanDetail(this.id);
      this.getBasicConfigData()
    }

  }
}
</script>
<style lang="scss" scoped>
.mobile-factoring-payment-plan-container{
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background: #f9f9f9;
  .top-title{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 0 0.3rem;
  }  
  /deep/ .el-tabs.el-tabs--top {
      border-top: 0.5px solid #f2f2f2;
      .el-tabs__header{
        background-color: #fff;
      }
      .el-tabs__item{
        font-size: .38rem !important;
      }
  }
  /deep/ .el-message{
    min-width: 7rem !important;
  }  
  .content-col{
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    border-bottom: 0.5px solid #f2f2f2;
    background: #fff;
    .content-title{
      text-align: center;
      font-size: 0.38rem;
      line-height: .5rem;
      height: .5rem;
      color: #333;
    }
    .init-content{
      color: #999;
      font-size: .36rem;
      line-height: .5rem;
      height: .5rem;
      text-align: center;      
    }
  }
  .panel-container{
    width: 100%;
    // padding-left: .25rem;
    // padding-right: .25rem;
  }
}
</style>